<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      
      <ion-tab-bar slot="bottom">
        <ion-tab-button tab="home" href="/tabs/home">
          <ion-icon :icon="homeOutline" />
          <ion-label>{{ t('nav.home') }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="scan" href="/tabs/scan">
          <ion-icon :icon="scanOutline" />
          <ion-label>{{ t('nav.scan') }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tickets" href="/tabs/tickets">
          <ion-icon :icon="receiptOutline" />
          <ion-label>{{ t('nav.tickets') }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="wallet" href="/tabs/wallet">
          <ion-icon :icon="walletOutline" />
          <ion-label>{{ t('nav.wallet') }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="alerts" href="/tabs/alerts">
          <ion-icon :icon="alertCircleOutline" />
          <ion-badge v-if="unreadCount > 0" color="danger">{{ unreadCount > 99 ? '99+' : unreadCount }}</ion-badge>
          <ion-label>{{ t('nav.alerts') }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="profile" href="/tabs/profile">
          <ion-icon :icon="personOutline" />
          <ion-label>{{ t('nav.profile') }}</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script setup lang="ts">
import { IonPage, IonTabs, IonTabBar, IonTabButton, IonIcon, IonLabel, IonRouterOutlet, IonBadge } from '@ionic/vue'
import { homeOutline, walletOutline, scanOutline, alertCircleOutline, receiptOutline, personOutline } from 'ionicons/icons'
import { ref, onMounted, onActivated } from 'vue'
import { useI18n } from '@/utils/i18n'
import { apiService } from '@/services/api'

const { t } = useI18n()
const unreadCount = ref(0)

const loadUnread = async () => {
  const token = localStorage.getItem('receiptai_token')
  if (!token || token === 'guest') { unreadCount.value = 0; return }
  try {
    const alerts = await apiService.alerts.getActive(undefined, 50)
    unreadCount.value = (alerts || []).filter((a: any) => !a.resolved).length
  } catch (e) {
    unreadCount.value = 0
  }
}

onMounted(() => {
  loadUnread()
  setInterval(loadUnread, 30000)
})

onActivated(() => {
  loadUnread()
})
</script>